import { reverse } from 'dns';
import { MutateOptions, useMutation, useQuery } from 'react-query';

import { TReviewDetail } from '../../../../../types/businessDetails.types';
import {
  addBusinessReviewRequest,
  getAddReview,
  getBusinessReviewsRequest,
  getReviewToken,
  publishBusinessReviewRequest,
} from './businessReviews.api';

export const useGetBusinessReviews = (businessId: string, options?) => {
  return useQuery<{ data: { data: TReviewDetail } }, Error>(
    ['businessReviews', businessId],
    () => getBusinessReviewsRequest(businessId),
    options,
  );
};

export const usePostBusinessReview = (
  businessId: string,
  accountId: string,
  options?: MutateOptions<any, Error, any>,
) => {
  return useMutation('addReview', {
    mutationFn: (data: any) => addBusinessReviewRequest(businessId, accountId, data),
    ...options,
  });
};

export const useGetReviewToken = (businessId: string, reviewToken: string, accountId: string, options?) => {
  return useQuery<any, Error, any>(
    ['reviewToken', reviewToken],
    () => getReviewToken(businessId, reviewToken, accountId),
    {
      ...options,
    },
  );
};
